export const GET_ACTIVE_USER_REPORTS = "GET_ACTIVE_USER_REPORTS"

export const GET_STUDENT_ATTENDANCE = "GET_STUDENT_ATTENDANCE"
export const GET_ALL_BATCHES = "GET_ALL_BATCHES"
export const GET_ALL_STUDENT = "GET_ALL_STUDENT"
export const GET_ALL_STUDENT_ATTENDANCE = "GET_ALL_STUDENT_ATTENDANCE"